import { render } from "./logo-visa.vue?vue&type=template&id=01471df0&scoped=true"
import script from "./logo-visa.js?vue&type=script&lang=js&external"
export * from "./logo-visa.js?vue&type=script&lang=js&external"

import "./logo-visa.scss?vue&type=style&index=0&id=01471df0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01471df0"]])

export default __exports__